import { axiosPost,axiosPostJson } from '../../../../../request/http';

const prexfix = global.$config.api.apiUrl;

// 投诉添加
export const SuggestAdd = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/member-api/member/suggest `, params)
};
 
 // 查询投诉信息列表
 export const GetSuggestList = (data) => {
   const params = {
     baseUrl: prexfix,
     data: data
   }
   return axiosPost(`/member-api/member/suggestList `, params)
 };
 
 // 查询投诉详情
 export const GetSuggestDetail = (data) => {
  let form = new FormData();
  form.append("id", data);
   
   return axiosPostJson(prexfix+`/member-api/member/suggestDetail`, form)
 };
 
 // 投诉处理
 export const SuggestUpdate = (data) => {
   const params = {
     baseUrl: prexfix,
     data: data
   }
   return axiosPost(`/member-api/member/suggestUpdate`, params)
 };
 
 // 获取投诉类型
 export const FindSDictionaryByGroupCode = (data) => {
     const params = {
       baseUrl: prexfix,
       data: data
     }
     return axiosPost(`/common-api/common/findSDictionaryByGroupCode`, params)
   };
 
 let ComplaintApi = {
    SuggestAdd,
    GetSuggestList,
    GetSuggestDetail,
    SuggestUpdate,
    FindSDictionaryByGroupCode
  };
  
  export default ComplaintApi;